import { useEffect } from "react";

import { invoicePreviewQuery_account_invoicePreview as Invoice } from "@zapier/checkout/esm/graphql-types";
import { useLocalStorage } from "@zapier/checkout/esm/hooks";

/* Capture date of invoice preview creation for tracking exchange rate at this date time */
export const setInvoicedAt = (
  invoice: Omit<Invoice, "__typename"> | null | undefined,
  isLoading: boolean
) => {
  const [invoicedAtDate, setInvoicedAtDate] = useLocalStorage("invoicedAtDate");

  useEffect(() => {
    if (!isLoading && invoice) {
      setInvoicedAtDate(invoice?.invoicedAt);
    }
  }, [invoice, invoicedAtDate, isLoading, setInvoicedAtDate]);
};
